import React, { useEffect } from 'react'
import CardCurso from './subComponents/CardCurso'
import { fetchApi } from '../../tools'

const Cursos = ({ urlCursos, state, send, headers, idCurso, idSede, sede, cursos, setCursos, contador, setContador }) => {


  const handleSeleccionado = (seleccionado, indiceXSubmenu, indiceYSubmenu) => {
    send("SELECCIONAR", { seleccionado: seleccionado.Horarios[indiceYSubmenu].Cargos[0] })
  }

  const getCursos = async () => {
    const response = await fetchApi({
      url: urlCursos + "/utils/busquedas",
      headers: headers,
      content: {
        Opcion: "CURSOS",
        IdCatalogo: idCurso,
        IdSede: state.context.sede,
        IdCursoD: state.context.idCursoD.IdCurso
      }
    })
    response.msg.forEach((element, index) => {
      element.Index = index
      element.Horarios.forEach((el, iy) => {
        el.Cargos.forEach((cargo, ix) => {
          cargo.Index = el.IdHorario // al horaio
          cargo.IdHorario = el.IdHorario
          cargo.Key = el.IdHorario
        })
      })
    });

    const cursosOrdenado = response.msg.sort((a, b) => a.IdCurso - b.IdCurso)
    setCursos(cursosOrdenado)
  }

  useEffect(() => {
    getCursos()
  }, [])

  return (
    <div>
      {/* <ResumenAlumno
        urlCursos={urlCursos}
        datosInscripcion={state.context.datosUsuario}
        carnet={state.context.carnet}
      /> */}
      <CardCurso
        data={cursos}
        setCursos={setCursos}
        handleClick={handleSeleccionado}
        textoBoton={"Agregar"} id="IdCurso" value="Curso"
        sede={sede}
        send={send}
        state={state}
        contador={contador}
        setContador={setContador}
      ></CardCurso>

    </div>
  )
}

export default Cursos